import { etichetaSursa } from "@/utils/targetareSurse";

type SursaBadgeProps = {
  sursa: string | null | undefined;
};

export default function SursaBadge({ sursa }: SursaBadgeProps) {
  const eticheta = etichetaSursa(sursa);
  if (!eticheta) return null;
  return (
    <span
      className="inline-flex shrink-0 rounded border border-muted-foreground/30 px-1 text-[10px] leading-4 text-muted-foreground"
      title={`Sursă: ${eticheta}`}
    >
      {eticheta}
    </span>
  );
}
